import { Patient } from "fhir/r5";
import { loadAllResources, loadResource } from "./FhirBundleService";

const PATIENT_SEARCH_PARAMS = {
  _count: "200",
  _elements: "id,name,identifier,active,gender,birthDate,telecom,address",
  _sort: "name",
};

async function loadPatient(patientId: string): Promise<Patient> {
  return loadResource<Patient>("Patient", patientId ?? "");
}

async function loadAllPatients(): Promise<Patient[]> {
  return loadAllResources<Patient>("Patient", PATIENT_SEARCH_PARAMS);
}

const PatientService = {
  loadPatient,
  loadAllPatients,
};

export default PatientService;
